import type { ColumnDef } from "@tanstack/react-table";
import type { ApReceipt } from "@/accounts-payable/types";

export const receiptNumberCol: ColumnDef<ApReceipt> = {
  accessorKey: "receipt_number",
  header: "Receipt #",
  meta: { size: "170px" },
  cell: ({ row }) => (
    <span className="tabular-nums">{row.original.receipt_number ?? "—"}</span>
  ),
};
